// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpenseRow_container__3PpV4","col":"ExpenseRow_col__1N0Zq","name":"ExpenseRow_name__17TtR","amount":"ExpenseRow_amount__i-3ws"};